module.exports = __webpack_public_path__ + "img/Account.041eedba.svg";